import React from "react";
import PageHeader from "../components/PageHeader";

export default function RTI() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
    { label: "Documents", link: "/documents" },
    { label: "RTI", active: true },
  ];

  const rtiDocuments = [
    {
      title: "Right To Information Act, 2005",
      link: "/assests/img/BareActsFiles/rti-act-2005_01.pdf",
    },
    {
      title: "Guidelines for Information seekers under the RTI Act, 2005",
      link: "/assests/img/BareActsFiles/Guidelines-on-rti_02.pdf",
    },
  ];

  return (
    <>
      {/* Page Header */}
      <PageHeader
        title="Right To Information (RTI)"
        breadcrumbs={breadcrumbs}
      />

      {/* RTI Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-4">
            Right To Information Act, 2005
          </h2>

          <div className="row g-4 justify-content-center">
            {rtiDocuments.map((doc, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="h-100 bg-white p-4 rounded-4 shadow-sm border-start border-4 border-primary text-center">
                  <h6 className="fw-bold text-primary mb-4">
                    {doc.title}
                  </h6>

                  <a
                    href={doc.link}
                    className="btn btn-sm btn-primary rounded-pill w-100"
                  >
                    View / Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
